export const environment = {
    production: false,
    sw: false,
    serverUrl: 'https://api.internal.scanner.ochnik.sandbox.cloud.codelabs.work',
    languages: {
        default: 'pl-PL',
        supported: [
            {
                key: 'pl-PL',
                regulations: '',
            },
        ],
    },
};
